/**
 * Префіл останнього email (convenience, spec §6). ЄДИНИЙ дозволений FE-persist
 * для auth — і то лише email, ніколи пароль/токен (ADR-0006 D6). Зберігаємо лише
 * коли `remember_me` відмічено на успішному вході; інакше — чистимо ключ.
 */
const KEY = "salonos.auth.lastEmail";

export function readLastEmail(): string {
  try {
    return localStorage.getItem(KEY) ?? "";
  }
  catch {
    return "";
  }
}

/** `remember=true` → зберегти email; інакше прибрати ключ. */
export function persistLastEmail(email: string, remember: boolean): void {
  try {
    if (remember && email) {
      localStorage.setItem(KEY, email);
    }
    else {
      localStorage.removeItem(KEY);
    }
  }
  catch {
    // приватний режим / quota — префіл некритичний, мовчки ігноруємо
  }
}
